import { readFromEnv, Env } from '@cinch-nx/environments'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { datadogRum } from '@datadog/browser-rum'
import { IdentifyNonCinchOwnershipRequest, VehicleOwnership } from './types'
import { Token } from '@cinch-labs/shared-util'

const vehicleOwnershipClient = axios.create({
  baseURL: readFromEnv(Env.VehicleOwnershipServiceUrl),
  validateStatus: () => true,
})

axiosRetry(vehicleOwnershipClient, {
  retries: 1,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: axiosRetry.isNetworkOrIdempotentRequestError,
})

export const getOwnerships = async (token: Token) => {
  const response = await vehicleOwnershipClient.get<{
    ownerships: VehicleOwnership[]
  }>('/vehicle-ownerships', {
    headers: {
      Authorization: `Bearer ${token?.access_token}`,
    },
  })

  if (response.status !== 200 || !response.data.ownerships) {
    datadogRum.addError(
      new Error('Cinch Servicing: Get ownerships - Failure'),
      {
        cinchServicing: true,
        apiEndpoint: '/vehicle-ownerships',
        statusCode: response.status,
      },
    )
    return { error: true }
  }

  return { error: false, ownerships: response.data.ownerships }
}

export const identifyNonCinchOwnership = async (
  token: Token,
  request: IdentifyNonCinchOwnershipRequest,
) => {
  const response = await vehicleOwnershipClient.post<{
    ownerships: VehicleOwnership[]
  }>('/vehicle-ownerships', request, {
    headers: {
      Authorization: `Bearer ${token?.access_token}`,
    },
  })

  if (response.status !== 201) {
    datadogRum.addError(
      new Error('Cinch Servicing: Create ownership - Failure'),
      {
        cinchServicing: true,
        apiEndpoint: '/vehicle-ownerships',
        statusCode: response.status,
      },
    )
  } else {
    datadogRum.addAction('Cinch Servicing: Add ownership - Success', {
      cinchServicing: true,
      apiEndpoint: '/vehicle-ownerships',
      statusCode: response.status,
      vin: request.vin,
    })
  }
}
